export enum PermissionType {
  ViewOnly = 0,
  AllAccess = 1,
  Hide = 2,
}

export enum PermissionTypeNew {
  None,
  ReadOnly,
  ReadWriteOnly,
  AllAccess,
}
